import React from 'react'
import { useState } from 'react'
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate } from 'react-router-dom'
import { logos } from '../../assets'
import { CustomCardRestorePassw } from '../../components'
import { requestNewPassword } from '../../api';
import { message } from 'antd';
import { emailValidation } from '../../validations/ValidationLogin';

export const RestorePassword = () => {
    const navigate = useNavigate()

    const [screen, setScreen] = useState(1)

    const onSubmit = async (values) => {
        const response = await requestNewPassword(values.email)
        if (response.status === 0) {
            setScreen(2)
        }
        else {
            setScreen(3)
            message.error("error")
        }
    }

    switch (screen) {
        case 1:
            return <div>
                < CustomCardRestorePassw>
                    <Formik
                        initialValues={{ email: "" }}
                        onSubmit={async (values) => onSubmit(values)}
                        validationSchema={emailValidation}
                    >
                        <Form className="h-full">
                            <div className='w-full h-2/6  flex justify-center items-center'>
                                <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
                            </div>
                            <div className='w-full h-2/6  flex flex-col  items-center px-12'>
                                <p className='font-bold text-2xl text-white'>Recuperación de contraseña</p>
                                <p className='text-white text-base font-normal py-4 text-center'>Ingresa tu correo electrónico y presiona el botón ‘’Reestablecer contraseña’’ para generar una nueva.</p>

                                <Field
                                    className="w-[454px] text-white p-2 bg-transparent border-b text-base focus:outline-none  border-white rounded placeholder:text-white"
                                    type="email"
                                    placeholder="Escribe tu correo electrónico"
                                    name="email"
                                    autoComplete="none"
                                />
                                <ErrorMessage component="a" className="text-red-600 " name="email" />
                            </div>
                            <div className='w-full h-2/6 '>
                                <div className='w-full text-center'>
                                    <button
                                        type="submit"
                                        className='w-[236px] h-[48px] rounded bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white text-base'>
                                        Reestablecer contraseña
                                    </button>
                                </div>
                                <p
                                    onClick={() => { navigate("/auth") }}
                                    className='text-white text-base font-normal mt-4 text-center cursor-pointer'>Regresar</p>
                            </div>
                        </Form>
                    </Formik>
                </CustomCardRestorePassw>
            </div>
        case 2:
            return <div>
                <CustomCardRestorePassw>
                    <div className='w-full h-2/6  flex justify-center items-center'>
                        <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
                    </div>
                    <div className='w-full h-2/6  flex flex-col items-center justify-center px-10'>
                        <p className='font-bold text-2xl text-white  text-center' >Se ha enviado un link para reestablecer tu contraseña.</p>
                        <p className='text-white text-base font-normal pt-6 text-center'>Un email con instrucciones fue enviado a tu correo. Por favor, revísalo.</p>
                    </div>
                    <div className='w-full h-2/6 flex justify-center items-center'>
                        <span className='text-[#66FFF6] text-base font-normal mt-4 text-center cursor-pointer pr-1.5 '>Da clic aquí</span>
                        <span className='text-white text-base font-normal mt-4 text-center'> para ir a tu correo en el buscador.</span>
                    </div>
                </CustomCardRestorePassw>
            </div>
        case 3:
            return <div>
                <CustomCardRestorePassw>
                    <div className='w-full h-2/6  flex justify-center items-center'>
                        <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
                    </div>
                    <div className='w-full h-2/6  flex flex-col items-center justify-center px-10'>
                        <p className='font-bold text-2xl text-white  text-center' >No hemos podido enviarte un link para reestablecer tu contraseña.</p>
                        <p className='text-white text-base font-normal pt-6 text-center'>Ha ocurrido un error, por favor vuelve a intentarlo.</p>
                    </div>
                    <div className='w-full h-2/6 '>
                        <div className='w-full text-center'>
                            <button
                                onClick={() => setScreen(1)}
                                className='w-[236px] h-[48px] rounded bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white text-base'>
                                Reestablecer contraseña
                            </button>
                        </div>
                        <p
                            onClick={() => { navigate("/auth") }}
                            className='text-white text-base font-normal mt-4 text-center cursor-pointer'>Regresar</p>
                    </div>
                </CustomCardRestorePassw>
            </div>
        default:
            setScreen(1)
            break;
    }

    //     return (
    //         <div className="">
    //             {
    //                 screen === 1
    //                     ?

    //                     :
    //                     <CustomCardRestorePassw>
    //                         <div className='w-full h-2/6  flex justify-center items-center'>
    //                             <img src={logos.inmersysLogin} className='w-[220px]' alt="logo inmersys" />
    //                         </div>
    //                         <div className='w-full h-2/6  flex flex-col items-center justify-center px-10'>
    //                             <p className='font-bold text-2xl text-white  text-center' >Se ha enviado un link para reestablecer tu contraseña.</p>
    //                             <p className='text-white text-base font-normal pt-6 text-center'>Un email con instrucciones fue enviado a tu correo. Por favor, revísalo.</p>
    //                         </div>
    //                         <div className='w-full h-2/6 flex justify-center items-center'>
    //                             <span className='text-[#66FFF6] text-base font-normal mt-4 text-center cursor-pointer pr-1.5 '>Da clic aquí</span>
    //                             <span className='text-white text-base font-normal mt-4 text-center'> para ir a tu correo en el buscador.</span>
    //                         </div>
    //                     </CustomCardRestorePassw>
    //             }
    //         </div>
    //     )
}

export default RestorePassword